export const wrapperStyles = {
  margin: '16px 20px',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
};

export const tableSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  alignItems: 'center',
};

export const tableWrapperStyles = {
  padding: 0,

  '& .table-cell__content_box': {
    overflow: 'visible',
  },
};
